<template>
	<section id="benefits" class="sg-section" style="background: linear-gradient(180deg, #FAF8F5, #FFF9F0);">
		<v-container>
			<h2 class="sg-section-title">مزایای خرید از طلای سیف زاده</h2>
			<div class="sg-gold-line"></div>
			<p class="sg-section-subtitle">چرا هزاران مشتری به ما اعتماد کرده‌اند؟</p>

			<v-row>
				<v-col v-for="(item, i) in benefits" :key="i" cols="12" sm="6" md="4" lg="2">
					<div class="sg-benefit-card">
						<div class="sg-benefit-icon">
							<v-icon color="#1a1a1a" size="32">{{ item.icon }}</v-icon>
						</div>
						<h3 class="font-weight-bold mb-2" style="font-size: 0.95rem;">{{ item.title }}</h3>
						<p class="grey--text text--darken-1 mb-0" style="font-size: 0.82rem; line-height: 1.7;">{{ item.desc }}</p>
					</div>
				</v-col>
			</v-row>
		</v-container>
	</section>
</template>

<script>
	export default {
		name: 'BenefitsSection',
		data() {
			return {
				benefits: [
					{
						icon: 'mdi-file-certificate',
						title: 'فاکتور طلای معتبر',
						desc: 'هر خرید همراه با فاکتور رسمی و مشخصات دقیق وزن و عیار',
					},
					{
						icon: 'mdi-swap-horizontal',
						title: 'امکان تعویض و عودت',
						desc: 'امکان تعویض یا عودت طلا طبق شرایط و ضوابط فروشگاه',
					},
					{
						icon: 'mdi-shield-check',
						title: 'ضمانت اصالت کالا',
						desc: 'تضمین اصالت و کیفیت طلا با گواهی معتبر',
					},
					{
						icon: 'mdi-draw-pen',
						title: 'ساخت سفارشی طلا',
						desc: 'طراحی و ساخت طلا بر اساس سلیقه و اندازه شما',
					},
					{
						icon: 'mdi-credit-card-clock',
						title: 'خرید قسطی طلا',
						desc: 'امکان خرید اقساطی طلا بدون دغدغه مالی',
					},
				],
			}
		},
	}
</script>
